import voca from "voca";
import get from "lodash.get";

const processJobContent = content => {
  let unescapedContent = voca.unescapeHtml(content);
  let stripped = voca.stripTags(unescapedContent, ["a", "p", "h2", "ul", "li"]);
  return voca.replaceAll(
    voca.replaceAll(
      voca.replaceAll(stripped, "<h2>", "<h3>"),
      "</h2>",
      "</h3>"
    ),
    "\n",
    ""
  );
};

function GetCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

const sortArray = (array, key) => {
  if (array && array.length > 0) {
    array.sort((a, b) => {
      if (get(a, key) < get(b, key)) {
        return -1;
      }

      if (get(a, key) > get(b, key)) {
        return 1;
      }

      return 0;
    });
  }
};

const organiseFeaturedPosts = content => {
  let featuredPostsList = [];

  content.forEach(({ post }) => {
    let postUid = post.uid;
    let postContent = post.document[0].data;

    featuredPostsList.push({
      title: postContent.title.text,
      uid: postUid,
      metadata: {
        primary: postContent.narrator.text,
        secondary: postContent.role.text
      },
      summary: postContent.summary.text,
      image: {
        desktop: postContent.image.url,
        mobile: postContent.image.mobile.url
      },
      mediumUrl: postContent.medium_url ? postContent.medium_url.url : ""
    });
  });

  return featuredPostsList;
};

// shamelessly stolen from https://gist.github.com/gordonbrander/2230317
// generates a (pseudo) unique id
const uniqId = () => {
  return (
    "_" +
    Math.random()
      .toString(36)
      .substr(2, 9)
  );
};

// from https://gist.github.com/guilhermepontes/17ae0cc71fa2b13ea8c20c94c5c35dc4
const shuffleArray = arr => {
  return arr.sort(() => {
    return Math.random() - 0.5;
  });
};

const EVENT_TYPE = "event";
const JOB_TYPE = "job";

// Datalayer event
function GTMEvent(name, params) {
  if (typeof window !== "undefined") {
    let predefined = {
      event: name
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign(predefined, params));
  }
}

export {
  GTMEvent,
  organiseFeaturedPosts,
  processJobContent,
  shuffleArray,
  sortArray,
  uniqId,
  GetCookie,
  EVENT_TYPE,
  JOB_TYPE
};
